module.exports = __webpack_public_path__ + "img/override.bbccbe5c.svg";